import PropTypes from 'prop-types'
import React from 'react'
import { Route, Redirect } from 'react-router-dom'

export const PublicRoute = ({
  isAuthenticated,
  noAuth,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      noAuth ? (
        <Component {...props} />
      ) : isAuthenticated ? (
        <Redirect to={process.env.REACT_APP_PREFIX} />
      ) : (
        <Component {...props} />
      )
    }
  />
)

PublicRoute.propTypes = {
  isAuthenticated: PropTypes.bool,
  noAuth: PropTypes.bool,
  component: PropTypes.object
}

export default PublicRoute
